<template>
  <el-container style="width: 100%;">
    <el-main>
      <el-table ref="multipleTable" :data="moduleData" tooltip-effect="dark" style="width: 100%" v-loading.body="fetchLoading">
        <el-table-column prop="name" :label="generateCustomizeString('moduleName')">
        </el-table-column>
        <el-table-column prop="sort_by" :label="generateCustomizeString('sortWeight')">
        </el-table-column>
        <el-table-column prop="is_show" :label="generateCustomizeString('moduleActivity')">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_show === 1" type="success" close-transition>
              {{generateCustomizeString('moduleReady')}}
            </el-tag>
            <el-tag v-else type="info" close-transition>
              {{generateCustomizeString('moduleWaitForReview')}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="250">
          <template slot-scope="scope">
            <el-button @click="editClick(scope.row)" type="text" size="small">{{generateCustomizeString('edit')}}</el-button>
            <el-button @click="enableClick(scope.row)" type="text" size="small">{{generateCustomizeString('enable')}}</el-button>
            <el-button @click="sortClick(scope.row)" type="text" size="small">{{generateCustomizeString('sort')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'PcCmsModules',
  data() {
    return {
      moduleData: [],
      fetchLoading: false
    }
  },
  methods: {
    generateCustomizeString,
    editClick(row) {
      let name = ''
      // let param = ''
      switch (row.type) {
        case 1:
          name = 'PcNavigate'
          break
        case 2:
          name = 'PcAdBanner'
          break
        case 4:
          name = 'PcGoodsModule'
          break
        case 5:
          name = 'PcBrandModule'
          break
        default:
          name = 'xxxx'
      }
      this.$router.push({
        name: name,
        params: { cms_home_category_id: row.id }
      })
    },
    enableClick(row) {},
    sortClick(row) {},
    fetchData() {
      if (this.fetchLoading) return
      this.fetchLoading = true

      request({
        url: '/cms-home-categories',
        method: 'get'
      })
        .then(response => {
          const data = response.data

          this.moduleData = data
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.fetchLoading = false
        })
    }
  },
  created: function() {
    this.fetchData()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
